module.exports = "/fonts/vendor/bootstrap-icons/bootstrap-icons.woff2?017203f08de6f4e2d40b4d746a0da2a5";